export default "__VITE_ASSET__Ta8e2yDZ__"